import React from 'react';
import {useFormContext} from 'react-hook-form';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';

import {ControllerWrapper} from '@/components/common';
import CheckBox from '@/components/help/common/CheckBox';
import {FORM_FIELDS} from '@/constants/help/form';

interface AgreementProps {
  label?: string;
}

const Agreement = ({
  label = '개인정보 수집 이용에 동의합니다.',
}: AgreementProps) => {
  const {
    formState: {errors},
  } = useFormContext();

  return (
    <div className={styles.agreementContainer}>
      <ControllerWrapper
        component={CheckBox}
        name={FORM_FIELDS.AGREEMENT}
        id={FORM_FIELDS.AGREEMENT}
        size='lg'
        label={label}
        rules={{required: '개인정보 수집 및 이용에 동의해 주세요.'}}
      />
      {errors.agreement && (
        <p className={styles.errorText}>{errors.agreement.message as string}</p>
      )}
    </div>
  );
};

export default Agreement;